export const S3_BASE = 'https://kilter-media.s3.us-east-2.amazonaws.com';
